import React from 'react';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/footer';
import SEO from 'components/common/SEO';
import { SEOProps } from '@/lib/seoData';
import CookieConsent from '../common/CookieConsent';
import Schema from '../common/Schema.org/BlogPosting';

type LayoutProps = {
  seo: SEOProps;
  schema?: any;
  children: React.ReactNode;
  isSignUp?: boolean;
};

const Layout = ({
  seo,
  schema,
  children
}: LayoutProps): React.ReactElement => {
  return (
    <div>
      <SEO seo={seo} />
      {schema && <Schema {...schema} />}
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex flex-col flex-grow flex-initial">{children}</main>
        <Footer />
      </div>
      <CookieConsent />
    </div>
  );
};

export default Layout;
